
















































































import Vue from 'vue';
import Component from 'vue-class-component';
import HomeChallengeButton from '@/components/home/HomeChallengeButton.vue';

@Component({
  components: {
    HomeChallengeButton
  }
})
export default class HomeCovi19New2 extends Vue {
  onNavigateToCovid() {
    const route = this.$router.resolve({
      path: '/challenges',
      query: {
        tag: 'COVID-19'
      }
    });
    if (route) {
      window.open(route.href, '_blank');
    }
  }
}
